import { render } from "./UserLevelStats.vue?vue&type=template&id=75b64632&scoped=true"
import script from "./UserLevelStats.vue?vue&type=script&lang=js"
export * from "./UserLevelStats.vue?vue&type=script&lang=js"

import "./UserLevelStats.vue?vue&type=style&index=0&id=75b64632&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b64632"]])

export default __exports__